import { all } from "redux-saga/effects";

import agendamento from "./modules/agendamentos/saga";
import clientes from "./modules/cliente/saga";
import colaborador from "./modules/colaborador/saga";
import servico from "./modules/servico/saga";
import horario from "./modules/horario/saga";
import Vans from "./modules/vans/saga";
import reserva from "./modules/reservaCarro/saga";
import admin from "./modules/admin/saga";

export default function* rootSaga (){
    return yield all([
        agendamento,
        clientes,
        colaborador,
        servico,
        horario,
        Vans,
        reserva,
        admin
    ])
}